import React from 'react'
import PropTypes from 'prop-types'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import { FormHelperText } from '@mui/material'
import { useTranslation } from 'react-i18next'
// import ReactCountryFlag from 'react-country-flag'
import phoneCountryCodes from '../../../util/phoneCountryCodes'

export default function PhoneCodeDropdown(props) {
  const { t } = useTranslation()

  const translatedmap = phoneCountryCodes.map((country) => ({
    ...country,
    tran: t(country.code)
  }))

  const sortedCountryCodes = [...translatedmap].sort((a, b) => a.tran.localeCompare(b.tran))

  return (
    <FormControl
      sx={{ minWidth: props.minWidth }}
      error={props.error}
    >
      <InputLabel
        id="demo-simple-select-label"
        shrink={false}
        sx={{
          '&.Mui-focused': {
            color: '#000000',
          },
          color: '#000000',
        }}
      >
        {props.value === '' && props.dropdownLabel}
      </InputLabel>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={props.value}
        sx={{
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#4545E0',
          },
          textAlign: 'initial',
          borderRadius: props.isMobile ? '10px' : '4px',
          minWidth: props.isMobile ? '16.1rem !important' : '25.6rem !important',
        }}
        onBlur={props.onBlur}
        renderValue={() => (t(props.value))}
      >
        <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
          {sortedCountryCodes.map((country) => (
            <MenuItem
              key={country.code}
              value={country.code}
              onClick={() => props.handleClick(country)}
            >
              {/* <ReactCountryFlag
              countryCode={country.code}
              svg
              style={{ marginRight: 8 }}
            /> */}
              {t(country.code)}
            </MenuItem>
          ))}
        </div>
      </Select>
      <FormHelperText>{props.error ? props.supportText : ''}</FormHelperText>
    </FormControl>
  )
}

PhoneCodeDropdown.propTypes = {
  value: PropTypes.string,
  minWidth: PropTypes.number,
  dropdownLabel: PropTypes.string,
  handleClick: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  error: PropTypes.bool,
  supportText: PropTypes.string,
  isMobile: PropTypes.bool,
}

PhoneCodeDropdown.defaultProps = {
  value: 'US',
  minWidth: 200,
  dropdownLabel: 'Gender',
  onBlur: () => { },
  error: false,
  supportText: '',
  isMobile: false,
}
